import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb, message } from 'antd'
import '../assets/css/raiseAccount.css'
import RaiseAcountForm from '../components/RaiseAcountForm'
import { getRaiseAccount } from '../api'

class RaiseAccount extends Component {
    constructor () {
        super()
        this.state = {
            type: 0, // 0为默认查询、1查询有内容、2查不到结果
            accountInfo: {
                accountName: '',
                accountNo: '',
                accountBank: ''
            }
        }
    }

    // 获取子组件、表单提交的数据
    getSubmitData = (data, callback) => {
        // 进行查询
        getRaiseAccount(data).then(res => {
            if (res.code === 'Success') {
                // 有数据
                if (res.returnObject) {
                    this.setState({
                        type: 1,
                        accountInfo: res.returnObject
                    })
                // 没数据
                }else {
                    this.setState({
                        type: 2
                    })
                }
                callback()
            }else if (res.code === 'Error') {
                message.error(res.message)
            }
        }).catch(err => {
            message.error(err.message)
        })

    }

    render () {
        const { accountName, accountNo, accountBank } = this.state.accountInfo
        return (
            <div>
                <div className="banner-item banner-raise">
                    <div className="l-container">
                        <h2>资产托管</h2>
                    </div>
                </div>
                <div className="page-title l-container">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item><a href="/gs/">首页</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/gs/business/">我们的业务</a></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/">资产托管与基金服务</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/raiseAccount">募集户核对</Link></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="page-content-raise l-container">
                    <div className="content-inner">
                        <div className="info">
                        特别提示：<b>募集户核对只适用于产品的募集账户监督机构为国信证券；</b>产品募集账户信息以基金合同为准，本页面账户信息仅供参考，由此导致的后果我司不承担任何法律责任；我司提供募集户核对功能并不代表募集账户监督机构接受投资者的认购、申购资金，也不表明募集账户监督机构对本基金的价值和收益作出实质性判断或保证，也不表明投资于本基金没有风险。
                        </div>
                        <div className="search-wrap">
                            {
                                this.state.type === 1 &&
                                <div className="search-result-1">
                                    <div className="search-result-title">
                                        募集户名称：{accountName}
                                    </div>
                                    <div className="search-result-content">
                                        <p>募集户账号：{ accountNo }</p>
                                        <p>开户行：   { accountBank }</p>
                                    </div>
                                </div>
                            }
                            {
                                this.state.type === 2 &&
                                <div className="search-result-2">
                                    该募集账户监督机构非国信证券或该募集账户不存在，请您再次核对基金合同，并注意您的财产安全。
                                </div>
                            }
                            <div className="search-condition">
                                <RaiseAcountForm getSubmitData={(data, callback) => this.getSubmitData(data, callback)}></RaiseAcountForm>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default RaiseAccount
